var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 w-100"},[_c('MapViewer',{staticClass:"p-0",on:{"map-ready":_vm.onMapReady}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }